import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/respimg/ls.respimg';
if (process.browser && !('object-fit' in document.createElement('a').style)) {
  require('lazysizes/plugins/object-fit/ls.object-fit');
}
import '@fortawesome/fontawesome-svg-core/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { appWithTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import React, { useEffect } from 'react';
import * as gtag from '../libs/gtag';
import nextI18NextConfig from '../next-i18next.config.js';
import { wrapper } from '~/store';
import registerFaIcons from '~/utils/registerFaIcons';
import '../static/fonts/common-fonts.css';

registerFaIcons();

const ACEditor = ({ Component, pageProps, err }) => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(
        '🚀  ~file: _app.js ~ line 22 ~ handleRouteChange ~ url',
        url,
      );
      gtag.pageview(url);
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    router.events.on('hashChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
      router.events.off('hashChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  useEffect(() => {
    // When login by SNS from SSO, SSO will redirect with query downloader_register=success
    // Then designAC will send event to GA
    if (router.query['downloader_register'] === 'success') {
      gtag.event({
        action: 'page_view',
        payload: { downloader_register: 'success' },
      });
    }
  }, []);

  return <Component {...pageProps} err={err} />;
};

export default wrapper.withRedux(
  appWithTranslation(ACEditor, nextI18NextConfig),
);
